var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "social-divider" }, [
        _c("span", { staticClass: "line1" }),
        _c("p", [_vm._v(_vm._s(_vm.$t("auth.or")))]),
        _c("span", { staticClass: "line2" }),
      ]),
      _c("div", { staticClass: "social-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "custom-btn social facebook-btn",
            attrs: { type: "button" },
            on: { click: _vm.facebookLogin },
          },
          [
            _c("img", { attrs: { src: _vm.iconFacebook, alt: "Facebook" } }),
            _c("span", [_vm._v("Facebook")]),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "custom-btn social linkedin-btn",
            attrs: { type: "button" },
            on: { click: _vm.linkedinLogin },
          },
          [
            _c("img", { attrs: { src: _vm.iconLinkedin, alt: "Linkedin" } }),
            _c("span", [_vm._v("LinkedIn")]),
          ]
        ),
      ]),
      _c("LoadingOverlay", { attrs: { show: _vm.isLoading } }),
      _c("CustomModal", {
        attrs: {
          show: _vm.dialog.show,
          title: _vm.dialog.title,
          message: _vm.dialog.message,
        },
        on: {
          close: function ($event) {
            _vm.dialog.show = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }